module.exports = __webpack_public_path__ + "static/media/bad-1.263179f6.svg";